import { render, staticRenderFns } from "./drawer_add.vue?vue&type=template&id=3579ddd2&scoped=true&"
import script from "./drawer_add.vue?vue&type=script&lang=js&"
export * from "./drawer_add.vue?vue&type=script&lang=js&"
import style0 from "./drawer_add.vue?vue&type=style&index=0&id=3579ddd2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3579ddd2",
  null
  
)

export default component.exports